// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2jx7K","footer__links":"styles_footer__links__2RXsZ","copyrate":"styles_copyrate__3Yv1e"};